

































































































































































































































































import {Vue, Component, Prop, Ref, Watch} from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class';
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { SelectWings, TemplateInputWings, FieldTooltip } from "wings-ui-components";
import { SmsTextInputWings } from '@/components/SMS';
import { MsgTransports } from '@/store/types';
import { PushTemplateItemImpl } from '@/store/settings/templates/types';
import { PushApplicationItem } from '@/store/push/application/types';
import { GenericTemplateInterface } from '@/pages/Pages/Templates/GenericTemplate';

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({components: {
    FieldTooltip,
    TemplateInputWings,
    GenericTemplate,
    SelectWings,
    SmsTextInputWings
}})
export default class PushTemplate extends Vue {
  @Prop() moderation!: boolean;
  @Ref('genericTemplate') genericTemplate!: GenericTemplateInterface;
  @Action("getPushApplications") actionGetApplications: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;
  @Action("getGroupsApplications") actionGetGroupsApplications: any;

  @Getter("applicationAttributes") applicationAttributesList: any;
  @Getter("pushApplications") applicationsList: any;
  @Getter("groupsApplications") groupApplicationsList: any;

  private transport: MsgTransports = MsgTransports.PUSH;
  private templateObject: PushTemplateItemImpl = new PushTemplateItemImpl();
  activeApplication: string = 'application';
  app_groups: {id: number; name: string}[] = [];
  applications: {id: number; name: string}[] = [];
  app_groups_ids: number[] = [];
  applications_ids: number[] = [];
  applicationsValue = '';

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }

  async onTemplateChangePartner(partner_id: number) {
    const appId = this.genericTemplate?.template.application_id;
    if (partner_id) {
      this.genericTemplate.template.application_id = null;
      await this.actionGetApplications({partner_id});
      await this.actionGetGroupsApplications({partner_id});

      if (this.applicationsList.some((app: PushApplicationItem) => app.id === appId))
        this.genericTemplate.template.application_id = appId;
    }
  }

  mounted() {
    if (this.genericTemplate && typeof this.genericTemplate.onSaveItem === 'function') {
      const originalOnSaveItem = this.genericTemplate.onSaveItem.bind(this.genericTemplate);
      this.genericTemplate.onSaveItem = async () => {
        if (this.activeApplication === 'application'){
          this.genericTemplate.template.applications_ids = this.applications_ids;
          this.genericTemplate.template.group_selection_rule = null;
          this.genericTemplate.template.app_selection_rule = null;
        } else {
          this.genericTemplate.template.app_groups_ids = this.app_groups_ids;
          this.genericTemplate.template.app_by_date = null;
        }
        if (this.genericTemplate.template.applications_ids!.length < 2) {
          this.genericTemplate.template.app_by_date = undefined
        }
        if (this.genericTemplate.template.app_groups_ids!.length < 2){
          this.genericTemplate.template.group_selection_rule = undefined
        }
        return originalOnSaveItem();
      };
    }
  }

  onAddApplication(id: number) {
    if (this.applications_ids.includes(id) || id == null) return;
    const option = this.applicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.applications.push(option);
    this.applications_ids.push(id);
  }

  onDeleteApplication(application: any) {
    const idx = this.applications.findIndex((item: any) => item.id == application.id);
    if (idx !== -1) {
      this.applications.splice(idx, 1);
      this.applications_ids.splice(idx, 1);
    }
  }

  onAddAppGroup(id: number) {
    if (this.app_groups_ids.includes(id) || id == null) return;
    const option = this.groupApplicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.app_groups.push(option);
    this.app_groups_ids.push(id);
  }

  onDeleteAppGroup(appGroup: any) {
    const idx = this.app_groups.findIndex((item: any) => item.id == appGroup.id);
    if (idx !== -1) {
      this.app_groups.splice(idx, 1);
      this.app_groups_ids.splice(idx, 1);
    }
  }

  onTemplateChanged(template: PushTemplateItemImpl) {
    if (!template.applications?.length) this.activeApplication = 'app_groups';
    this.applications = template.applications || [];
    this.applications_ids = this.applications.map(app => app.id);
    this.app_groups = template.app_groups || [];
    this.app_groups_ids = this.app_groups.map(app => app.id);
  }

  onChangeApplicationId() {
    if (this.genericTemplate.template.application_id) {
      this.actionGetApplicationAttributes({application_id: this.genericTemplate.template.application_id})
    }
  }

  onLoadTemplate(status: string) {
    if (this.moderation) this.$emit('onLoadTemplate', status)
  }

  @Watch('activeApplication', { immediate: false })
  onChangeActiveApplication(newVal: string, oldVal: string) {
    this.applicationsValue = '';
    if (newVal === 'application') {
      this.app_groups = [];
      this.app_groups_ids = [];
      this.templateObject.app_groups = [];
      this.templateObject.app_groups_ids = [];
      this.templateObject.group_selection_rule = null;
      this.templateObject.app_selection_rule = null;
    } else {
      this.applications = [];
      this.applications_ids = [];
      this.templateObject.applications = [];
      this.templateObject.applications_ids = [];
      this.templateObject.app_by_date = null;
    }
  }
}
